module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "templates-managerment"
  }, [_c('h1', [_vm._v("模板管理")]), _c('div', {
    staticClass: "templates"
  }, _vm._l((_vm.templates), function(t) {
    return _c('div', {
      staticClass: "template"
    }, [_c('div', {
      staticClass: "icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.get_icon_url(t.type)
      }
    })]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(t.desc || t.name))]), _c('div', {
      staticClass: "filename"
    }, [_vm._v(_vm._s(t.template))]), _c('div', {
      staticClass: "last_update"
    }, [_vm._v(_vm._s(t.last_update))]), _c('div', {
      staticClass: "action-buttons"
    }, [_c('i', {
      staticClass: "icon download",
      on: {
        "click": function($event) {
          _vm.download(t)
        }
      }
    }), _c('file-upload', {
      ref: "uploader-" + t.name,
      refInFor: true,
      attrs: {
        "name": "template",
        "post-action": _vm.action_path(t),
        "accept": _vm.accept(t)
      },
      on: {
        "input": function (files) { return _vm.filesChanged(t, files); },
        "input-file": _vm.inputFile
      }
    }, [_c('i', {
      staticClass: "icon upload cloud"
    })])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c57307d","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Admin/TemplatesManagement.vue
// module id = 465
// module chunks = 0